import React, { useState, useEffect } from "react";
import { useLocation } from "@reach/router";
import { useDispatch, useSelector } from "react-redux";
import queryString from "query-string";
import {
  updateOrderSettingModalIsVisible,
  getChildLocations,
  setIsStoreDeepLink,
  setIsParentStoreDeepLink,
  setParentLocation,
  updateInterOrderType,
  updateInterPickUpDetails,
  updateInterDeliveryDetails,
  updateInterDropOffDetails,
} from "../modules/OrderSetting/orderSettingActions";
import {
  PICKUP,
  DELIVERY,
  DROPOFF,
} from "../modules/OrderSetting/orderSettingTypes";
import appConfig from "../../app-config";

function useDeepLink() {
  const dispatch = useDispatch();
  const urlQuery = useLocation();

  const { locations } = useSelector((state) => state.locationsReducer);
  const {
    childLocations,
    parentLocation,
    interOrderType,
    isParentDeepLink,
    isDeepLink,
  } = useSelector((state) => state.orderSettingReducer);

  useEffect(() => {
    if (
      parentLocation &&
      urlQuery &&
      urlQuery.search &&
      appConfig.isDeepLinkClient
    )
      dispatch(getChildLocations(parentLocation.id));
  }, [parentLocation]);

  const findAndSetParentLocation = (parentId) => {
    if (locations) {
      const parentStore = locations.find(
        (location) => location.id === parseInt(parentId)
      );

      if (parentStore) {
        dispatch(setParentLocation(parentStore));
        dispatch(setIsParentStoreDeepLink(true));
      }
    }
  };

  const findAndSetChildLocation = (storeId) => {
    if (childLocations) {
      const store = childLocations.find(
        (location) => location.id === parseInt(storeId)
      );
      if (store && interOrderType === PICKUP) {
        dispatch(updateInterPickUpDetails(store, new Date().toString()));
        dispatch(setIsStoreDeepLink(true));
      } else if (store && interOrderType === DELIVERY) {
        dispatch(updateInterDeliveryDetails(store, new Date().toString()));
        dispatch(setIsStoreDeepLink(true));
      } else if (store && interOrderType === DROPOFF) {
        dispatch(updateInterDropOffDetails(store, new Date().toString()));
        dispatch(setIsStoreDeepLink(true));
      }
    }
  };

  const findAndSetLocation = (storeId) => {
    if (locations) {
      const store = locations.find(
        (location) => location.id === parseInt(storeId)
      );
      if (store && interOrderType === PICKUP) {
        dispatch(updateInterPickUpDetails(store, new Date().toString()));
        dispatch(setIsStoreDeepLink(true));
      } else if (store && interOrderType === DELIVERY) {
        dispatch(updateInterDeliveryDetails(store, new Date().toString()));
        dispatch(setIsStoreDeepLink(true));
      } else if (store && interOrderType === DROPOFF) {
        dispatch(updateInterDeliveryDetails(store, new Date().toString()));
        dispatch(setIsStoreDeepLink(true));
      }
    }
  };

  useEffect(() => {
    if (urlQuery && urlQuery.search && appConfig.isDeepLinkClient) {
      const query = queryString.parse(urlQuery.search);
      if (
        query.parentId &&
        query.storeId &&
        childLocations &&
        !isParentDeepLink &&
        !isDeepLink
      ) {
        findAndSetParentLocation(query.parentId);
        findAndSetChildLocation(query.storeId);
      }

      if (query.parentId && !isParentDeepLink) {
        findAndSetParentLocation(query.parentId);
      }

      if (query.storeId && !isDeepLink) {
        findAndSetLocation(query.storeId);
      }

      if (query.type && !isParentDeepLink)
        dispatch(updateInterOrderType(query.type));
    }
  }, [locations, childLocations]);
}

export default useDeepLink;
